 
import {get_province} from '@/api/province'
export const state = {
    provinces: [],
    loading: false,
    selectProvince: null 
    
}

export const getters = {
    provinces: state => state.provinces, 
    selectProvince: state => state.selectProvince, 
    loading: state => state.loading, 
}

export const mutations = {
    getProvince(state) {
        state.loading = true
    },
    getProvinceDone(state, payload) {
        state.loading = false
        state.provinces = payload
    },
    getProvinceFail(state, payload) {
        state.loading = false
        state.provinces = []
    },
    setProvince(state, payload) {
        state.selectProvince = payload 
    },
   
}
export const actions = {
    async  getProvince({ commit }, payload) {
        commit('getProvince')
        try {
            const data = await get_province(payload)
            commit('getProvinceDone',data)
        } catch (error) {
            commit('getProvinceFail')
        }
    } ,
    setProvince({ commit }, payload) {
        commit('setProvince',payload)
    }
  
}
